import { memo } from 'react';
import { Box, Skeleton } from '@betty/moonlight';

function WithdrawPaymentsSkeleton() {
  return (
    <Box paddingTop="space-400" paddingHorizontal="space-600" gap="space-400">
      <Skeleton height={21.6} />
      <Skeleton height={97} borderRadius="radius-200" />
      <Skeleton height={97} borderRadius="radius-200" />
    </Box>
  );
}

export default memo(WithdrawPaymentsSkeleton);
